
const selectorsCommonHE = {
  "selectors_clear": "הכל",
}

const selectorsPlaceholdersHE = {
  "selectors_grower_placeholder": "בחר מגדל",
  "selectors_car_placeholder": "בחר רכב",
  "selectors_warehouse_placeholder": "בחר מחסן",
  "selectors_teudaType_placeholder": "בחר סוג תעודה",
  "selectors_product_placeholder": "בחר מוצר",
  "selectors_size_placeholder": "בחר גודל",
  "selectors_package_placeholder": "בחר אריזה",
  "selectors_palletType_placeholder": "בחר משטח",
  "selectors_report_placeholder": "בחר דוח",
}

const selectorsEmptyHE = {
  "selectors_grower_empty": "אין מגדלים מתאימים",
  "selectors_car_empty": "אין רכבים מתאימים",
  "selectors_warehouse_empty": "אין מחסנים מתאימים",
  "selectors_teudaType_empty": "אין סוגים מתאימים",
  "selectors_product_empty": "אין מוצרים מתאימים",
  "selectors_size_empty": "אין גדלים מתאימים",
  "selectors_package_empty": "אין אריזות מתאימות",
  "selectors_palletType_empty": "אין משטחים מתאימים",
  "selectors_report_empty": "אין דוחות מתאימים",
  "selectors_location_empty": "אין איתורים מתאימים",
}

export const selectorsTranslationHE = {
  selectors: {
    ...selectorsCommonHE,
    ...selectorsPlaceholdersHE,
    ...selectorsEmptyHE,
  }
}
